export const isComplementEditedByUser = items =>
  Boolean(items && items.complement && items.complement.editedByUser);
